<template>
  <v-container>
    <h3>サーベイ情報</h3>
    <v-layout row　align-center>
      <v-spacer />
      <v-flex md3>
        <v-btn @click="editInfo" v-if="auths.includes('EditSurveySummary')">
          <v-icon>edit</v-icon>編集
        </v-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog">
      <v-card v-if="info && info.name">
        <v-card-title class="headline grey lighten-2" primary-title>サーベイ情報の編集</v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex md4>
              <v-text-field v-model="info.name" label="研修名" required></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md4>
              <simple-date-input v-model="info.training_date" label="研修日" />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md6 sm12>
              <simple-datetime-input
                v-model="infoItems.start_date"
                :read-only="true"
                label="サーベイ開始日時"
              />
            </v-flex>
            <v-flex md6 sm12>
              <simple-datetime-input
                v-model="infoItems.end_date"
                :read-only="true"
                label="サーベイ終了日時"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md6 sm12></v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog=false">閉じる</v-btn>
          <v-btn @click="updateItem">更新</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table :items="items" hide-actions hide-headers class="elevation-1">
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{props.item.label}}</td>
          <td>{{props.item.value}}</td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import { unixtimeToFormattedDate } from "@/utils/datetime.js";
import SimpleDatetimeInput from "@/components/common/simpleDatetimeInput.vue";
import SimpleDateInput from "@/components/common/simpleDateInput.vue";
import { mapGetters } from "vuex";
export default {
  components: { SimpleDatetimeInput, SimpleDateInput },
  props: {
    infoItems: {}
  },
  data() {
    return {
      items: [],
      info: {},
      dialog: false,
      name: ""
    };
  },
  computed:{
    ...mapGetters("auth", ["auths"]),
  },
  mounted() {
    this.updateTable();
  },
  methods: {
    updateItem() {
      this.$emit("updateItem", this.info);
    },
    updateTable() {
      this.items = [];
      this.items.push({ label: "研修名", value: this.infoItems.name });
      this.items.push({
        label: "研修日",
        value: unixtimeToFormattedDate(this.infoItems.training_date)
      });
      this.items.push({
        label: "対象者サーベイ数",
        value: this.infoItems.num_of_subjects
      });
      this.items.push({
        label: "協力者サーベイ数",
        value: this.infoItems.num_of_users
      });
      this.items.push({
        label: "サーベイ期間",
        value:
          unixtimeToFormattedDate(this.infoItems.start_date) +
          " - " +
          unixtimeToFormattedDate(this.infoItems.end_date)
      });
    },
    editInfo() {
      const { name, training_date } = this.infoItems;
      this.info = JSON.parse(JSON.stringify({ name, training_date }));
      this.dialog = true
    }
  },
  watch: {
    infoItems() {
      this.updateTable();
    }
  }
};
</script>